import React from 'react';
import { Button } from '@fluentui/react-components';
import { WeatherSunnyRegular, WeatherMoonRegular } from '@fluentui/react-icons';
import { IThemeToggleProps } from './IThemeToggleProps';
import strings from './strings';

const ThemeToggle: React.FC<IThemeToggleProps> = ({ theme, onToggle }) => (
  <Button
    appearance="subtle"
    size="small"
    icon={theme === 'dark' ? <WeatherSunnyRegular /> : <WeatherMoonRegular />}
    onClick={onToggle}
    aria-label={strings.label}
    title={theme === 'dark' ? strings.switchToLight : strings.switchToDark}
  >
    {theme === 'dark' ? strings.switchToLight : strings.switchToDark}
  </Button>
);

export default ThemeToggle;
